import { useState, type SyntheticEvent } from 'react';
import { ApiError } from '../api/client.js';
import { useAuth } from '../auth.js';

export function LoginPage() {
  const { login, startupError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(
    startupError ? `Cannot reach the server: ${startupError}` : null,
  );
  const [busy, setBusy] = useState(false);

  async function submit(e: SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) setError('Invalid email or password.');
      else setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form
        className="login-card"
        onSubmit={(e) => {
          void submit(e);
        }}
        noValidate
      >
        <div className="login-brand">
          <span className="brand-mark" aria-hidden="true">
            K
          </span>
          <h1>Kalvio</h1>
        </div>
        <p className="muted">Sign in to continue.</p>
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </label>
        <label className="field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </label>
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={busy || !email || !password}
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        {import.meta.env.VITE_MOCK === '1' && (
          <p className="hint">Mock mode: any email, password “kalvio”.</p>
        )}
      </form>
    </div>
  );
}
